import { render } from "./Bag.vue?vue&type=template&id=016cf5fc&scoped=true&ts=true"
import script from "./Bag.vue?vue&type=script&lang=ts"
export * from "./Bag.vue?vue&type=script&lang=ts"

import "./Bag.vue?vue&type=style&index=0&id=016cf5fc&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016cf5fc"]])

export default __exports__